import moment from 'moment'

// Dates arrive already in the game's timezone, so they are formatted as-is.
export const formatDate = (value) => (value ? moment(value).format('D MMM YYYY') : '-')
export const formatTime = (value) => (value ? moment(value).format('h:mm a') : '')

export const initialsOf = (name) =>
  (name || '?')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('')
